import { Block } from '@mote/ui'
import React from 'react'
import styled from 'styled-components'
import { useMotePlayer } from '../../../shared/contexts/motePlayer.context'
import { MoteCardRichAvatarWithAnimation } from '../MoteCardRichAvatarWithAnimation'
import { MoteCardRichControls } from '../MoteCardRichControls'
import { MoteCardRichFullTranscriptText } from '../MoteCardRichFullTranscriptText'
import { MoteCardRichTranscriptionInline } from '../MoteCardRichTranscriptionInline'

export const MoteCardActiveState = ({
  createdByName,
  createdByAvatar,
  transcript
}) => {
  const {
    play,
    pause,
    paused: isPaused,
    showFullTranscript,
    playerDimensions
  } = useMotePlayer()

  return (
    <Root
      align='center'
      justify='center'
      onClick={event => {
        const selection = document.getSelection()
        if (selection.type === 'Range') return event.stopPropagation()

        if (isPaused) play()
        else pause()
      }}
      isPaused={isPaused}
    >
      {showFullTranscript && (
        <MoteCardRichFullTranscriptText transcript={transcript} />
      )}
      <Block spreadX align='center'>
        {!showFullTranscript && (
          <>
            <MoteCardRichAvatarWithAnimation
              transcript={transcript}
              createdByAvatar={createdByAvatar}
              createdByName={createdByName}
            />
            {transcript && (
              <MoteCardRichTranscriptionInline transcript={transcript} />
            )}
          </>
        )}
        <MoteCardRichControls />
      </Block>
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
  overflow: hidden;

  &:hover {
    .mote-card-controls-root {
      transform: translateY(0);
      transition: transform 150ms ease-out 0s;
    }
    .floating-duration-container {
      opacity: 0;
      transition: opacity 150ms ease-out 0s;
    }
  }
`
